/**
@version 1.11
@changelog
	1.1 podpora pro horizontalni productListy
	1.2 fix bugu v Safari u productlist normalizace vysek
	1.3 podpora pro data-grouping-rows u ProductList
	1.4 srovnani produktu
	1.5 osetreni peknejsich heroslideru bez buttonu
	1.6 opraven problem s ajaxovym kosikem, kdyz neni na instanci potreba
	1.7 vyladeno vyskakovaci menu v mainmenu_text s vice sloupecky
	1.8 .no-ajax u nakupovacĂ„â€šĂ‚Â­ch buttonĂ„Ä…ÄąÂ»
	1.9 podpora pro dynamickĂ„â€šĂ‚Â© submenu
	1.10 hvÄ‚â€žĂ˘â‚¬ĹźzdiÄ‚â€žÄąÂ¤ky (oblĂ„â€šĂ‚Â­benĂ„â€šĂ‚Â© produkty)
	1.11 data_click_to_expand - podpora pro vĂ„Ä…Ă„Äľdy rozbalovacĂ„â€šĂ‚Â­ dynamic submenu
@preserve
*/

$(function() {

	// Responsive handles
	$(".responsive-handle[data-target]").click(function() {
		$($(this).attr("data-target")).toggleClass("visible");
		if ($(this).is(".responsive-handle-once")) $(this).hide();
	});

	// Main menu submenu repositioning
	$(".mainmenu-text").find("li.with-submenu").hover(function() {
		var $this=$(this);
		$this.css("z-index",10);
		var $sub=$this.find(".submenu");
		var fixWidth=function() {
			var totalw=0;		
			var count = 0;	
			$sub.find("ul, .menu-list").each(function() {
				totalw+=$(this).outerWidth();
				count++;
			});
			$sub.width(totalw+count);		
			var space=$this.closest(".container").outerWidth();
			var w=$sub.width();
			var l=Math.round($this.position().left);
			if (l+w > space) {
				$sub.css("left",
					space-w-l
				);
			}			
		};
		window.setTimeout(fixWidth,20);
		window.setTimeout(fixWidth,50);
		window.setTimeout(fixWidth,120);
		window.setTimeout(fixWidth,220);
	},function() {
		var $this=$(this);
		$this.css("z-index",1);
		$this.find(".submenu").css("z-index",10);
		window.setTimeout(function() {
			$this.find(".submenu").css("z-index",1);
		},300);
	});

	// Main menu with images and background - same heights
	var $mains=$(".mainmenu-images.with-background div.main-category .name");
	if ($mains.length) {
		var maxH=0;
		var h;
		$mains.each(function() {
			h=$(this).outerHeight();
			if (h>maxH) maxH=h;
		});
		$mains.outerHeight(maxH);
	}

	// Productlist height
	function normalizeHeights($container,piecesSelector) {
		var $prods=$container.find(piecesSelector);
		var maxims=0;
		$prods.each(function() {
			$th=$(this);
			$th.css("height","auto");
			$th.find(".description").css("height","auto");
			$th.find(".stretcher").css("height","auto");
			var h=$th.outerHeight();
			if (!maxims || maxims<h) maxims=h;
		});
		$prods.each(function() {
			$th=$(this);
			var h=$th.outerHeight();
			if (maxims!=h) {
				var $desc=$th.find(".description");
				if ($desc.length) {
					var secondParam = false;
					// if ($.browser.safari) secondParam = true; // Safari weird bug - odkomentuj, pokud nastĂ„â€šĂ‹â€ˇvĂ„â€šĂ‹â€ˇ
					$desc.outerHeight($desc.outerHeight()+maxims-h, secondParam);
					$desc.css("max-height","200px"); // shorten-X classes
				} else {
					$th.find(".stretcher").height(maxims-h);
				}
				$th.outerHeight(maxims);
				if ($desc.data("dotdotdot")) {
					$desc.trigger("update");
				}
			}
		});
	};

	$(".normalize-height").each(function() {
		var _this=this;
		normalizeHeights($(_this),".product");
	});

	window.SSNormalizeHeights=normalizeHeights;

	// Product link fix for IE 7 
	if (navigator.userAgent && navigator.userAgent.match(/MSIE [567]/i)) {
		$(".image img").click(function() {
			var $a=$(this).closest("a");
			if ($a[0]) $a[0].click();
		});
	}

	// Brands slider 
	$(".brands-slider .main-part").each(function() {
		var $masterCont=$(this).closest(".brands-slider");
		var $uberMaster=$masterCont.closest(".brands");
		var x=1;
		var y=0;
		if ($masterCont.is(".vertical-slider")) {
			x=0;
			y=1;
		}
		var auto = 7000;
		if ($masterCont.is(".without-auto")) auto=false;	
		$(this).slidehide({
			"slides": ".brand",
			"auto": auto,
			"speed":800,
			"x":x,
			"y":y,
			"grouping": function() {
				var groupNumber=8;
				var measured=Math.floor($masterCont.width()/$masterCont.find(".brand").outerWidth(true)+0.1);
				if (measured<8) groupNumber=measured;		
				return groupNumber;				
			}, 
			"arrowNext":$uberMaster.find(".next"),
			"arrowPrev":$uberMaster.find(".prev"),
			"windowResize":true,
			"touch":true
		});	
	});	

	// Hero slider
	$("#hero .button-row *:empty").remove();
	$("#hero .button-row").each(function() {
		var $th = $(this);
		if (!$.trim($th.text())) {
			$th.closest(".slide").addClass("hidden-button");
			$th.remove();
		}
	});


	// Products slidehide
	$(".products-slider .main-part").each(function() {
		var $masterCont=$(this).closest(".products-slider");
		var selector = ".product, .product-horizontal, .slider-item";
		var x=1;
		var y=0;
		var alpha=false;
		if ($masterCont.is(".vertical-slider")) {
			x=0;
			y=1;
		}
		if ($masterCont.is(".slider-alpha-only")) {
			x=0;
			y=0;
			alpha=true;
		}
		var forcedGrouping = $(this).attr("data-grouping");
		var groupingVal;
		if (forcedGrouping) groupingVal = forcedGrouping;
		else groupingVal = function() {
			var groupNumber=6;
			var measured=Math.floor($masterCont.width()/$masterCont.find(selector).outerWidth(true)+0.1);
			if (measured<6) groupNumber=measured;
			var rows = $(this).attr("data-grouping-rows");
			if (rows > 0 && rows < 5) {
				groupNumber *= rows;
			}
			return groupNumber;
		};
		var auto = 7000;
		if ($masterCont.is(".without-auto")) auto=false;
		$(this).slidehide({
			"slides": selector,
			"auto": auto,
			"x":x,
			"speed":400,
			"y":y,
			"alpha":alpha,
			"grouping": groupingVal,
			"buttons": $masterCont.find(".pagination"),
			"buttonsPattern":"<li><a href='#'>%i%</a></li>",
			"arrowNext":$masterCont.find(".next"),
			"arrowPrev":$masterCont.find(".prev"),
			"windowResize":true,
			"touch":true
		});		
	});

	// SETabContainer
	var handleTabClick=function () {
		//if ($(this).is(".on")) return false;
		$container=$(this).closest(".tab-container");
		$container.children(".tabs").find("li").removeClass("on");
		$(this).addClass("on");
		var target=$(this).attr("data-target");
		$container.children(".box").children().hide();
		$("#"+target).show().find(".forms-full-width-input").animatoFullWidthInput();
	};
	$(".tab-container>.tabs li").click(handleTabClick);
	$(".tab-container").each(function() {
		$(this).children(".box").children(".tab-content").hide();
		var $onTabs=$(this).find(">.tabs li.on");
		var $allTabs=$(this).find(">.tabs li");
		if (!$allTabs.length) return;
		if ($onTabs.length) handleTabClick.call($onTabs[0]);
			else handleTabClick.call($allTabs[0]);
	});


	// Things important on mobile that should be moved to top
	if ($(window).width()<700) {
		var $target=$("#important-on-mobile-target");
		if ($target.length) {
			$(".important-on-mobile").each(function() {
				$(this).appendTo($target);
			});
		}
	}

	// Dynamic submenu
	$(".submenu-dynamic .expander").each(function() {
		var $div = $(this).closest("[data-master]");
		if ($div.is(".rozbalena, .on")) {
			$div.addClass("expanded");
		}
	}).addClass("initialised-expander");

	$(".submenu-dynamic").on("click", ".expander", function() {
		var $this = $(this);
		var $div = $this.closest("[data-master]");
		var myLevel = $div.attr("data-level");
		var $menu = $this.closest(".submenu-dynamic");
		var $subs = [];
		var stopped = false;
		$div.nextAll().each(function() {
			var $nextThis = $(this);
			if (!stopped && $nextThis.attr("data-level") > myLevel) {
				$subs.push(this);
			} else {
				stopped = true;
			}
		});
		$subs = $($subs);
		var currentId = $this.attr("data-id");

		if ($div.is(".expanded")) {
			$div.removeClass("expanded");
			$subs.slideUp(300);

		} else {
			// open
			$div.addClass("expanded");
			if ($subs.length > 0) { // Pouze zobrazit jiĂ„Ä…Ă„Äľ naÄ‚â€žÄąÂ¤tenĂ„â€šĂ‚Â©
				$subs.slideDown(300);
			} else { // NaÄ‚â€žÄąÂ¤Ă„â€šĂ‚Â­st ajaxem
				var feedUrl = $menu.attr("data-feed-url");
				$.get(feedUrl, {"id": currentId}, function(responseJson) {
					var levelAdd = $menu.attr("data-level-add") * 1;
					var $pointInsertion = $div;
					var inserted = [];
					var totalLength = responseJson.length;
					$.each(responseJson, function(i, r) {
						var level = levelAdd + (r.uroven * 1);
						var $node = $("<div></div>");
						$node.addClass("level"+level);
						$node.attr("data-level", level);
						$node.attr("data-master", currentId);
						if (r.isParent) {
							$node.addClass("rodic");
						}
						if (i == 0) {
							$node.addClass("first");
						} 
						if (i == totalLength - 1) {
							$node.addClass("last");
						}
						var $lines = $("<span class='lines'></span>");
						$node.append($lines);
						if (r.isParent) {
							var $expander = $("<a href='#' class='expander' data-id='"+r.id+"'><span class='sign'></span></a>");
							$lines.append($expander);
						}
						for (var i = 2; i <= level; i++) {
							$lines.append("<span class='line line-"+i+"'><span class='hline'></span></span>");
						}						
						$node.append($("<a class='menulink' href='"+r.odkaz+"'></a>").text(r.nadpis));
						$pointInsertion.after($node);
						inserted.push($node[0]);
						$pointInsertion = $node;
					});
					$(inserted).hide().slideDown(200);
				}, "json");
			}
		}
		return false;
	});

	$(".submenu-dynamic.always-expand").on("click", ".menulink", function() {
		var $expander = $(this).siblings(".lines").find(".expander");
		if ($expander.length) {
			$expander.trigger("click");
			return false;
		}
	});
	

	// Content page remove padding

	var removeContentPagePadding=function() {
		var $th=$(this);
		$th.css("position","static");
		$th.css("left","");		
		$th.css("width","");
		var w=$th.width();
		$th.css("position","relative");
		$th.css("left","-10px");
		$th.width(w+10);	
		$th.css("max-width",(w+10)+"px");
	};
	$(".remove-content-page-padding").each(removeContentPagePadding);
	$(window).resize(function() {
		$(".remove-content-page-padding").each(removeContentPagePadding);		
	});

	// Adding SVG triangles
	$(".submenu").find(".on").each(function() {
		$arrow=$('<span data-svgObject="triangleRight" class="arrow"></span>');
		$(this).append($arrow);
		$arrow.renderSvgObject();
	});

	// Ajax cart
	if ($().ajaxKosik) {
		$(".buy a.btn:not(.no-ajax)").ajaxKosik({
			"loadingText":$(".buy a.btn").html(),
			"loadingClass":"loading"
		});
		$(".buy:not(.no-ajax)").closest("form").ajaxKosik({
			"loadingText":$(".buy .btn").html(),
			"loadingClass":"loading",
			"loadingTarget":".buy .btn"
		});	
	}

	// Product details page

	$("input.autoselect-on-focus").focus(function() {
		$(this).select();
	}).select();


	// Users menu popups

	var isHoverOutLocked=false;
	function planHoverOut($menu) {
		window.setTimeout(function() {
			if (!isHoverOutLocked) {
				$menu.stop(true,true).addClass("invisible");
			}
		},600);				
	};
	$("a.show-users-menu").each(function() {
		var $a=$(this);
		var $container=$a.closest(".navbar, .header");
		var $menu=$container.find(".users-popup-menu");
		$a.hover(function() {
			$menu.stop(true,true).removeClass("invisible");
		},function() {
			isHoverOutLocked=false;	
			planHoverOut($menu);
		});
	});
	$(".users-popup-menu").hover(function() {
		isHoverOutLocked=true;
	},function() {
		isHoverOutLocked=false;
		planHoverOut($(this).closest(".users-popup-menu"));
	});


	// Compare
	var compareModeActive = false;
	function toggleCompareMode(active) {
		if (active === "toggle") {
			active = !compareModeActive;
		}
		if (active) { // Activate
			$(".page-pagination").hide();
			$("#se-sorting").hide();
			$("#compare-control").removeClass("inactive");
			compareModeActive = true;
			$("#productlist-main").addClass("selectable");
			$("#productlist-main .product").on("click.selectable", function() {
				$(this).toggleClass("selected");
				refreshCompareControl();
				return false;
			});
			$("#productlist-main .product a, #productlist-main .product button").on("click.selectable", function(e) {
				$(this).closest(".product").trigger("click");
				e.stopImmediatePropagation();
				return false;
			});
			refreshCompareControl();

		} else { // Deactivate
			$(".page-pagination").show();
			$("#compare-bottom").addClass("inactive");
			$("#se-sorting").show();
			$("#compare-control").addClass("inactive");
			$("#productlist-main").removeClass("selectable");
			$("#productlist-main .product").off("click.selectable").removeClass("selected");
			$("#productlist-main .product a, #productlist-main .product button").off("click.selectable");
			compareModeActive = false;
			refreshCompareControl();

		}
	}

	function refreshCompareControl() {
		if (compareModeActive) {
			var selectedCount = $("#productlist-main .product.selected").length;

			if (selectedCount > 0) {
				$("#compare-bottom").removeClass("inactive");
				$("#compare-mode-submit").show();
			} else {
				$("#compare-bottom").addClass("inactive");
				$("#compare-mode-submit").hide();
			}
			
			$("#compare-control .text-block>div").each(function() {
				var $th = $(this);
				$th.html($th.html().replace("%count%", "<span class='count'></span>"));
				$th.find(".count").html(selectedCount);
			}).hide();

			if (selectedCount == 0) $("#compare-control .zero").show();
			if (selectedCount == 1) $("#compare-control .one").show();
			if (selectedCount >= 2 && selectedCount <= 4) $("#compare-control .two").show();
			if (selectedCount >= 5) $("#compare-control .five").show();
		}
	}

	$("#compare-mode-toggle").click(function() {
		toggleCompareMode("toggle");
		return false;
	});
	$("#compare-mode-cancel").click(function() {
		toggleCompareMode(false);
		return false;
	});
	$("#compare-mode-submit, #compare-bottom button").click(function() {
		var ids = [];
		var $selected = $("#productlist-main .product.selected");
		if (!$selected.length) return false;
		$selected.each(function() {
			ids.push($(this).attr("data-prod-id"));
		});
		var param=$.param({"srovnat":ids});
		window.location = "eshop-srovnani.html?"+param;
		return false;
	});

	// OblĂ„â€šĂ‚Â­benĂ„â€šĂ‚Â© 
	$(".product .star").click(function() {
		var $star = $(this);
		var id = $star.closest(".product").attr("data-prod-id");
		$.get("favorite-eshop-products-api.html?akce=toggle&cil="+id, function(response) {
			if (response.success) {
				if (response.added) {
					$star.addClass("star-active");
				} else {
					$star.removeClass("star-active");
				}
				$(".header .favorites .number").text(response.favs.length);
				if (response.favs.length == 0) {
					$(".header .favorites").addClass("no-favorites");
				} else {
					$(".header .favorites").removeClass("no-favorites");
				}
				var $popup = $star.find(".popup");
				$popup.text(response.message);
				$popup.addClass("visible");
				window.setTimeout(function() {
					$popup.removeClass("visible");
				}, 2000);
			}
		});
	});

	$(".product-favorite-star").click(function() {
		var $star = $(this);
		var id = $star.attr("data-prod-id");
		if (!id) {
			return;
		}
		$.get("favorite-eshop-products-api.html?akce=toggle&cil="+id, function(response) {
			if (response.success) {
				if (response.added) {
					$star.addClass("star-active");
				} else {
					$star.removeClass("star-active");
				}
				$(".header .favorites .number").text(response.favs.length);
				if (response.favs.length == 0) {
					$(".header .favorites").addClass("no-favorites");
				} else {
					$(".header .favorites").removeClass("no-favorites");
				}				
				var $popup = $star.find(".popup");
				$popup.text(response.message);
				//$popup.addClass("visible");
				//window.setTimeout(function() {
				//	$popup.removeClass("visible");
				//}, 2000);				
			}
		});
	});	

	$(".lang").click(function() {

		$(".icon-lang").toggleClass("is-active");
		$(this).toggleClass("active");

	});

	$("#user").click(function(){

		$(".user").toggleClass("visible");

	});

	$("#search").click(function(){

		$(".cart-search").toggleClass("visible");

	});

	$("#hamburger").click(function(){

		$(".menu").toggleClass("menu-visible");

	});

});

